



































































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import SelectAttendeesStep from './select-attendees-step.vue';
import ChoosePaymentMethodStep from './choose-payment-method-step.vue';
import { Invoice } from '@accounting/interfaces/invoice';
import { Payment } from '@accounting/interfaces/payment';
import { ActivitySession } from '@activities/interfaces/activity-session';
import { PaymentMethodOption, SavedTicketApiResponse } from '@activities/interfaces/activity';
import {
  ActivitySessionAttendeeExportObject,
  ActivitySessionAttendeeOptionGroup,
} from '@core/interfaces/option-group';

import { ContactAttendeeInformation } from '@activities/interfaces/activity-session-attendee';
import BlockingOverlay from '@shared/components/overlay/blocking-overlay.vue';

@Component({
  name: 'bpc-session-attendee-modal',
  components: {
    'bpc-choose-payment-method-step': ChoosePaymentMethodStep,
    'bpc-select-attendees-step': SelectAttendeesStep,
    'bc-blocking-overlay': BlockingOverlay,
  },
})
export default class SessionAttendeeModal extends Vue {
  $refs: {
    choosePaymentMethodStep: InstanceType<typeof ChoosePaymentMethodStep> & {
      subscriptionOptions: object;
    };
  };
  // PROPS
  @Prop({ type: String, default: 'session-attendee-modal' })
  readonly modalId: string;
  @Prop({ type: Boolean, default: false }) readonly loading: boolean;
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({
    type: Number,
  })
  readonly sessionId: number;
  @Prop({
    type: Number,
  })
  readonly activityId: number;

  // DATA
  showModalIndex = 0;
  contactsLoaded = false;
  selectedContactId: number = null;
  step = 'add-attendees';
  savingAttendees = false;
  processFinished: boolean = false;
  selectedPaymentMethod: { payment_method: string; subscription: number } = {
    payment_method: null,
    subscription: null,
  };
  ticket: Invoice = null;
  payment: Payment = null;
  paymentData = {};
  showAlert: boolean = false;
  alertVariant: string = 'null';
  alertMessage: string = '';
  allowedPaymentMethods: PaymentMethodOption[] = [];
  continuePayment = false;
  showOptionGroupAlert: boolean = false;
  optionGroupAlertMessage: string = '';
  optionGroupAlertMaxNumber: number = 0;
  waitingList: boolean = false;
  isPopupOpen: boolean = false;
  paymentId: number = null;
  paymentStatus: string = null;

  // Data to manage option groups
  optionGroups: ActivitySessionAttendeeOptionGroup = null;
  mergedOptionGroups: ActivitySessionAttendeeExportObject = null; // We store here the result of a merge between the fixedOptions and the variableOptions

  // COMPUTED
  get contactId() {
    return this.$authorizationService.getContactId();
  }

  get parsedPaymentMethod(): string {
    return this.selectedPaymentMethod.payment_method === 'stripe_card'
      ? 'card'
      : this.selectedPaymentMethod.payment_method;
  }

  get showMoneyTransferPaymentInfo(): boolean {
    return (
      (this.step === 'paid' || this.step === 'pay-ticket') &&
      !!this.ticket &&
      this.parsedPaymentMethod === 'money_transfer'
    );
  }

  get showPayFipPaymentInfo(): boolean {
    return (
      (this.step === 'paid' || this.step === 'pay-ticket') && this.parsedPaymentMethod === 'payfip'
    );
  }

  // LIFECYCLE
  async mounted() {
    this.showModalIndex = Date.now();
    this.initVars();
    if (this.showModal) {
      this.openModal();
    }
    this.checkIfWaitingList();
  }

  // METHODS
  async checkIfWaitingList() {
    const basePath = this.$bpcApiRouteHelper.getEntityPath('activity-sessions');
    const path = `${basePath}/${this.sessionId}`;
    const res = await this.$bpcApi.get(path, null, 'admin').toPromise();
    const withWaitingList = res.data.with_waiting_list;
    const numberOfAttendees = res.data.num_attendees;
    const maxParticipants = res.data.max_participants;
    if (withWaitingList && numberOfAttendees >= maxParticipants && maxParticipants > 0) {
      this.waitingList = true;
    } else {
      this.waitingList = false;
    }
  }

  async onContinuePaymentClicked(event: {
    session: ActivitySession;
    contactAttendeeInformation: ContactAttendeeInformation;
  }) {
    this.selectedContactId = event.contactAttendeeInformation.contact_id;
    this.goToStep('payment-method');

    this.continuePayment = true;
  }

  previousStep() {
    switch (this.step) {
      case 'add-attendees':
        break;
      case 'payment-method':
        this.goToStep('add-attendees');
        break;
      case 'pay-ticket':
        this.goToStep('payment-method');
        break;
      default:
        this.goToStep('add-attendees');
        break;
    }
  }

  async nextStep() {
    switch (this.step) {
      case 'add-attendees':
        await this.selectAttendees();
        break;
      case 'payment-method':
        await this.payAttendees();
        break;
      case 'paid':
        this.closeModal();
        break;
      default:
        this.goToStep('add-attendees');
        break;
    }
  }

  goToStep(step: string) {
    this.continuePayment = false;
    this.step = step;
  }
  onContactsLoaded() {
    this.contactsLoaded = true;
  }

  initVars() {
    // this.invoiceGenerationEventsError = [];
    // this.invoiceGenerationEventsSuccess = [];
    // this.invoiceGenerationRequestSent = false;
    // this.isGeneratingInvoices = false;
    // this.generateInvoiceErrors = null;
  }

  get hasSelectedContacts(): boolean {
    return !!this.selectedContactId;
  }

  async selectAttendees() {
    if (this.hasSelectedContacts) {
      this.goToStep('payment-method');
    } else {
      this.$bpcMessage.showWarningMessage({
        text:
          'activities.session_attendee_modal_warning_you_have_to_select_a_contact_to_attend_the_session',
      });
    }
  }

  onPaymentMethodsLoaded(paymentMethodOptions: PaymentMethodOption[]) {
    this.allowedPaymentMethods = paymentMethodOptions;
  }

  onOptionsLoaded(options: ActivitySessionAttendeeOptionGroup) {
    this.optionGroups = options;
  }

  showAlertMessage(variant, message) {
    this.alertVariant = variant;
    this.alertMessage = message;
    this.showAlert = true;
  }

  onErrorPayment($event) {
    this.showAlertMessage('danger', $event.message);
  }

  onAddFamilyMember() {
    this.$emit('add-family-member-clicked');
  }

  closeModal() {
    this.showModalIndex = Date.now();
    this.$emit('close-modal');
    this.initVars();
  }

  async addToWaitingList() {
    this.savingAttendees = true;
    const basePath = this.$bpcApiRouteHelper.getEntityPath('activity-session-waiting-contacts');
    const path = `${basePath}/${this.sessionId}/add-to-waiting-list/${this.selectedContactId}`;
    await this.$bpcApi.post(path, {}).subscribe(
      res => {
        this.$bpcMessage.showSuccessMessage({ text: 'global.generic.successful_action' });
        this.closeModal();
      },
      error => {
        console.log(error);
        this.$bpcMessage.showErrorMessage({
          text: 'global.error.already_in_waiting_list',
        });
      },
    );
    this.savingAttendees = false;
  }

  get successPaymentUrl(): string {
    const origin = window.location.origin;
    const path = window.location.pathname;
    const query = [
      '?session_id={CHECKOUT_SESSION_ID}',
      'step=checkout-confirmation',
      'status=success',
    ].join('&');
    return `${origin}${path}${query}`;
  }
  get cancelPaymentUrl(): string {
    const origin = window.location.origin;
    const path = window.location.pathname;
    const query = [
      '?session_id={CHECKOUT_SESSION_ID}',
      'step=checkout-confirmation',
      'status=cancel',
    ].join('&');
    return `${origin}${path}${query}`;
  }

  async payAttendees() {
    this.savingAttendees = true;
    if (
      this.selectedPaymentMethod.payment_method === 'subscription' &&
      !this.selectedPaymentMethod.subscription
    ) {
      this.$bpcMessage.showWarningMessage({
        text: 'activities.session_attendee_modal_warning_you_have_to_select_a_subscription_to_pay',
      });
      return;
    } else if (!this.selectedPaymentMethod.payment_method) {
      this.$bpcMessage.showWarningMessage({
        text: 'activities.session_attendee_modal_warning_you_have_to_select_a_payment_method',
      });
    } else {
      // Get the current active attendees of the selected contact taking into account the date of the session
      const basePath = this.$bpcApiRouteHelper.getEntityPath('activity-sessions');
      const query =
        this.selectedPaymentMethod.payment_method === 'subscription'
          ? `?subscription_id=${this.selectedPaymentMethod.subscription}`
          : '';
      const path = `${basePath}/${this.sessionId}/active-contact-attendees/${this.selectedContactId}${query}`;
      const result = await this.$bpcApi.get(path, {}).toPromise();

      // Check here that the contact can be attended according to the option groups
      // Priorities: Subscription category -> Activity -> Center setting
      this.mergedOptionGroups = this.optionGroups.fixed_options;

      if (this.selectedPaymentMethod.payment_method === 'subscription') {
        // Get the selected subscriptionCategoryId
        const subscriptionCategoryId =
          this.$refs.choosePaymentMethodStep?.subscriptionOptions?.find(
            item => item.id == this.selectedPaymentMethod.subscription,
          )?.subscription_category_id || null;

        // Get the corresponding options
        if (subscriptionCategoryId) {
          const variableOptions = this.optionGroups.variable_options.subscription_categories[
            subscriptionCategoryId
          ];
          if (variableOptions) {
            this.mergedOptionGroups = { ...this.mergedOptionGroups, ...variableOptions };
          }
        }
      }

      // Check the options
      let canAttend = true;
      if (
        this.mergedOptionGroups.max_weekly_active_attendees &&
        this.mergedOptionGroups.max_weekly_active_attendees <=
          result.data.session_week_active_attendees
      ) {
        canAttend = false;
        this.showOptionGroupAlert = true;
        this.optionGroupAlertMessage =
          'global.reached_max_active_attendee_per_week_options_message';
        this.optionGroupAlertMaxNumber = this.mergedOptionGroups.max_weekly_active_attendees;
      }

      if (
        this.mergedOptionGroups.max_global_active_attendees &&
        this.mergedOptionGroups.max_global_active_attendees <= result.data.global_active_attendees
      ) {
        canAttend = false;
        this.showOptionGroupAlert = true;
        this.optionGroupAlertMessage = 'global.reached_max_active_attendee_options_message';
        this.optionGroupAlertMaxNumber = this.mergedOptionGroups.max_global_active_attendees;
      }

      if (!canAttend) {
        this.showOptionGroupAlert = true;
        this.savingAttendees = false;
      } else {
        this.showOptionGroupAlert = false;
        this.optionGroupAlertMessage = '';
        this.savingAttendees = true;

        try {
          const basePath = this.$bpcApiRouteHelper.getEntityPath('activity-sessions');
          const path = this.continuePayment
            ? `${basePath}/${this.sessionId}/pay-contact-attendees/${this.contactId}`
            : `${basePath}/${this.sessionId}/add-attendee-from-fo`;
          const body = {
            payment_method: this.selectedPaymentMethod.payment_method,
            subscription: this.selectedPaymentMethod.subscription,
            contact_id: this.selectedContactId,
            success_url: this.successPaymentUrl,
            cancel_url: this.cancelPaymentUrl,
          };

          const res: SavedTicketApiResponse = await this.$bpcApi
            .post(path, body, null, 'admin')
            .toPromise();
          const paidWithSubscription = res.data.paid_with_subscription;
          const isFree = res.data.is_free;

          if (paidWithSubscription || isFree) {
            this.$emit('attendees-paid');
            this.closeModal();
          } else {
            this.ticket = res.data.invoice;
            this.payment = res.data.payment;

            const paidWithMoneytransfer =
              this.selectedPaymentMethod.payment_method === 'money_transfer';
            if (paidWithMoneytransfer) {
              this.goToStep('paid');
            } else {
              const urlRedirect = res.data.paymentResponse.response.redirectUrl;
              const openInAPopUp = res.data.paymentResponse.response.openInAPopUp;
              this.paymentId = res.data.paymentResponse.paymentId;
              if (openInAPopUp) {
                this.goToStep('pay-ticket');
                const popup = window.open(
                  urlRedirect,
                  '_blank',
                  'height=700, width=900,toolbar=no, menubar=no, scrollbars=no, resizable=yes, location=no, directories=no, status=no',
                );
                this.isPopupOpen = true;
                if (popup) {
                  const focusPopup = () => {
                    if (!popup.closed) {
                      popup.focus();
                    }
                  };

                  window.addEventListener('click', focusPopup);
                  const checkPopupClosed = setInterval(() => {
                    if (popup.closed) {
                      clearInterval(checkPopupClosed);
                      window.removeEventListener('click', focusPopup);
                      this.isPopupOpen = false;
                    }
                  }, 500);
                  this.checkPaymentStatus(this.paymentId);
                }
              } else {
                window.location.href = urlRedirect;
              }
            }
          }
          // get the ticketId and the price and maybe orders
        } catch (error) {
          this.manageSaveAttendeesErrors(error);
        }
        this.savingAttendees = false;
      }
    }
  }

  checkPaymentStatus(paymentId: number) {
    this.$bpcEcho
      .getOnlinePaymentStatusChannel(paymentId)
      .listen('.BPC\\Accounting\\Events\\OnlinePaymentSuccess', async data => {
        this.$bpcEcho.leaveOnlinePaymentStatusChannel(this.paymentId);
        this.paymentStatus = 'success';
        this.processFinished = true;
      })
      .listen('.BPC\\Accounting\\Events\\OnlinePaymentFailed', async data => {
        this.$bpcEcho.leaveOnlinePaymentStatusChannel(this.paymentId);
        this.paymentStatus = 'failed';
        this.processFinished = true;
      });
  }

  manageSaveAttendeesErrors(error) {
    console.log(error);
  }

  openModal() {
    this.$bvModal.show(this.modalId);
  }

  get currentSelectedPaymentMethod() {
    return this.selectedPaymentMethod?.payment_method;
  }

  // WATCHERS

  @Watch('showModal')
  onShowModalChange(val) {
    if (val) {
      this.openModal();
    } else {
      this.$bvModal.hide(this.modalId);
    }
  }
  @Watch('currentSelectedPaymentMethod')
  onSelectedPaymentMethodChange() {
    this.showOptionGroupAlert = false;
    this.optionGroupAlertMessage = '';
  }
}
